export default __webpack_public_path__ + "static/media/Leaving-For-Valhalla(AlexanderNakarada).5b4d6299.mp3";